export default __webpack_public_path__ + "static/media/twitter.0f16884a.svg";